// @flow

import React from 'react';
import { NavLink } from 'react-router-dom';
import Text from './Typography';

type Props = {
  className: string,
  links: Array
}

const NavDropdown = ({ className, links }: Props) => (
  <ul className={`navbar-link__sub-menu__list ${className}`}>
    {links.map((link) => (
      link.internal ?
        <li className='navbar-link__sub-menu__item' key={link.title}>
          <NavLink
            to={link.url}
            className='navbar-link__sub-menu__link'
            activeClassName='is-active'
            onClick={link.onClick && link.onClick}
          >
            {link.title}
          </NavLink>
        </li>
        : <li className='navbar-link__sub-menu__item' key={link.title}>
          <Text link className='navbar-link__sub-menu__link' href={link.url}>
            {link.title}
          </Text>
        </li>
    ))}
  </ul>
);

export default NavDropdown;


// WEBPACK FOOTER //
// ./src/components/shared/NavDropdown.js